import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { BackgroundImage } from "@/interfaces/themes"
import { useStudentStore } from '@/stores/student'

export function useThemes() {
  const { t } = useI18n()
  const studentStore = useStudentStore()

  const backgroundThemes = computed<BackgroundImage[]>(() => {
    const themes: BackgroundImage[] = [
      {
        name: t('pages.dashboard.theme_settings.default'),
        filename: 'inherit',
      },
      {
        name: t('pages.dashboard.theme_settings.background_1'),
        filename: 'background-1',
      },
      {
        name: t('pages.dashboard.theme_settings.background_2'),
        filename: 'background-2',
      },
      {
        name: t('pages.dashboard.theme_settings.background_3'),
        filename: 'background-3',
      },
      {
        name: t('pages.dashboard.theme_settings.background_4'),
        filename: 'background-4',
      },
      {
        name: t('pages.dashboard.theme_settings.background_5'),
        filename: 'background-5',
      },
      {
        name: t('pages.dashboard.theme_settings.background_6'),
        filename: 'background-6',
      },
    ]

    if (studentStore.hasCustomBackground) {
      themes.push({
        name: t('pages.dashboard.theme_settings.custom'),
        filename: 'custom',
        url: studentStore.customBackgroundUrl!,
      })
    }

    return themes
  })

  return { backgroundThemes }
}
